import React from "react";
import styles from "./NavItem.module.css";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconName } from "@fortawesome/fontawesome-svg-core";

type NavItemProps = {
  path: string;
  icon: IconName;
  text: string;
  active: boolean;
  indent?: boolean;
  isNotClickable?: boolean;
  onClick?: () => void;
};

export const NavItem = (props: NavItemProps) => {
  const { onClick = () => {} } = props;
  if (props.isNotClickable) {
    return (
      <div
        className={classnames(
          styles.notClickable
        )}
      >
        <div className={styles.greenBar}></div>
        <FontAwesomeIcon className={styles.icon} icon={props.icon} />
        <span>{props.text}</span>
      </div>
    );
  } else {
    return (
      <div
        className={classnames(
          styles.root,
          { [styles.active]: props.active },
          { [styles.indent]: props.indent }
        )}
      >
        <div className={styles.greenBar}></div>
        <Link to={props.path} onClick={onClick}>
          <FontAwesomeIcon className={styles.icon} icon={props.icon} />
          <span>{props.text}</span>
        </Link>
      </div>
    );
  }
};

export default NavItem;
